module.exports = __webpack_public_path__ + "img/뱀파이어.5ee424db.png";